import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "competences-container" }
const _hoisted_2 = { class: "tabs-container" }
const _hoisted_3 = { class: "competences-grid" }
const _hoisted_4 = { class: "competence-card-header" }
const _hoisted_5 = { class: "competence-icon" }
const _hoisted_6 = { class: "competence-title-section" }
const _hoisted_7 = { class: "competence-badge" }
const _hoisted_8 = { class: "competence-description" }
const _hoisted_9 = { class: "competence-card-content" }
const _hoisted_10 = { class: "apprentissage-header" }
const _hoisted_11 = { class: "apprentissage-code" }
const _hoisted_12 = { class: "apprentissage-desc" }
const _hoisted_13 = { class: "projects-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("header", { class: "competences-header" }, [
      _createElementVNode("h1", null, "Mes Compétences"),
      _createElementVNode("p", { class: "subtitle" }, "Un aperçu de mon évolution technique et méthodologique")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["tab-btn", { active: _ctx.activeTab === 's5' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 's5'))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("i", { class: "mdi mdi-numeric-5-box-outline" }, null, -1),
        _createElementVNode("span", null, "Semestre 5", -1)
      ]), 2),
      _createElementVNode("button", {
        class: _normalizeClass(["tab-btn", { active: _ctx.activeTab === 's6' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 's6'))
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("i", { class: "mdi mdi-numeric-6-box-outline" }, null, -1),
        _createElementVNode("span", null, "Semestre 6", -1)
      ]), 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentCompetences, (competence, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index + _ctx.activeTab,
          class: "competence-card",
          style: _normalizeStyle({ '--competence-color': competence.color })
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("i", {
                class: _normalizeClass(competence.icon)
              }, null, 2)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, "Compétence " + _toDisplayString(competence.competence), 1),
              _createElementVNode("h2", null, _toDisplayString(competence.title), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(competence.description), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(competence.children.filter(c => c.projects.length > 0), (child, childIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: childIndex,
                class: "apprentissage-item"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(child.code), 1),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(child.description), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.projects, (project, pIndex) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: pIndex,
                      to: project.url,
                      class: "project-chip"
                    }, {
                      default: _withCtx(() => [
                        _cache[4] || (_cache[4] = _createElementVNode("i", { class: "mdi mdi-folder-open-outline" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(project.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ], 4))
      }), 128))
    ])
  ]))
}